/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { BirthDay } from '../models/birthday.model';
import { SlotsbyDate } from '../models/SlotsbyDate';
import { Visitor } from '../models/visitor';
import { VisitorChild } from '../models/visitorChild';
import { Visitor1 } from '../models/visitor1';
import { VisitorChild1 } from '../models/visitorChild1';
import { BirthdayModelInputDTO } from '../models/birthdayModelInputDTO';
import { BirthdayOutput } from '../pages/kartica-visitora/kartica-visitora.page';
import { BirthdayOutputDTO } from '../models/birthdayOutputDTO';

export type ChildInput = { fullName: string; birthDate: string };

type VisitorSearchQuery = {
  currentPage: number;
  itemsPerPage: number;
  fullNameQuery: string;
  emailQuery: string;
  phoneQuery: string;
  visitorStatusQuery: string;
  onlyChildren: boolean;
  onlyParents: boolean;
  marketingMessageQuery: string;
  dateBirthFromQuery: string;
  dateBirthToQuery: string;
  registrationDateFromQuery: string;
  registrationDateToQuery: string;
  visitorBirthMonthFromQuery: string;
  visitorBirthMonthToQuery: string;
  visitorBirthYearFromQuery: string;
  visitorBirthYearToQuery: string;
  roomNameQuery: string;
};

type VisitorExportQuery = VisitorSearchQuery & {
  pageSize: number;
};

@Injectable({
  providedIn: 'root'
})

export class VisitorService {
  apiUrl = environment.apiUrl;
  private visitorsSource = new ReplaySubject<any>(1);
  private paginationSource = new ReplaySubject<any>(1);
  visitors$ = this.visitorsSource.asObservable();
  paginationSettings$ = this.paginationSource.asObservable();

  private readonly defaultVisitorSearchQuery: VisitorSearchQuery = {
    currentPage: 1,
    itemsPerPage: 20,
    fullNameQuery: '',
    emailQuery: '',
    phoneQuery: '',
    visitorStatusQuery: '',
    onlyChildren: false,
    onlyParents: false,
    marketingMessageQuery: '',
    dateBirthFromQuery: '',
    dateBirthToQuery: '',
    registrationDateFromQuery: '',
    registrationDateToQuery: '',
    visitorBirthMonthFromQuery: '',
    visitorBirthMonthToQuery: '',
    visitorBirthYearFromQuery: '',
    visitorBirthYearToQuery: '',
    roomNameQuery: ''
  };

  private readonly defaultVisitorExportQuery: VisitorExportQuery = {
    ...this.defaultVisitorSearchQuery,
    pageSize: 2147483647
  };

  constructor(private http: HttpClient) { }

  getAllVisitors() {
    let params = new HttpParams();

    return this.http.get(this.apiUrl + 'visitor', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitorsSource.next(res.body);
      }
    })).toPromise();
  }

  deleteVisitor(id) {
    return this.http.delete(`${this.apiUrl}visitor/${id}`);
  }

  getAllVisitorsSearch(queryParams: Partial<VisitorSearchQuery> = {}) {
    queryParams = { ...this.defaultVisitorSearchQuery, ...queryParams };
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('emailQuery', queryParams.emailQuery);
    params = params.append('phoneQuery', queryParams.phoneQuery);
    params = params.append('visitorStatusQuery', queryParams.visitorStatusQuery);
    params = params.append('marketingMessageQuery', queryParams.marketingMessageQuery);
    params = params.append('dateBirthFromQuery', queryParams.dateBirthFromQuery);
    params = params.append('dateBirthToQuery', queryParams.dateBirthToQuery);

    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('registrationDateFromQuery', queryParams.registrationDateFromQuery);
    params = params.append('registrationDateToQuery', queryParams.registrationDateToQuery);
    params = params.append('visitorBirthMonthFromQuery', queryParams.visitorBirthMonthFromQuery);
    params = params.append('visitorBirthMonthToQuery', queryParams.visitorBirthMonthToQuery);
    params = params.append('visitorBirthYearFromQuery', queryParams.visitorBirthYearFromQuery);
    params = params.append('visitorBirthYearToQuery', queryParams.visitorBirthYearToQuery);
    params = params.append('roomNameQuery', queryParams.roomNameQuery);

    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    params = params.append('onlyChildren', queryParams.onlyChildren);
    params = params.append('onlyParents', queryParams.onlyParents);
    return this.http.get(this.apiUrl + 'visitor/SearchVisitors', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitorsSource.next(res.body);
      }
    })).toPromise();
  }

  getAllVisitorIdSearch(queryParams = {
    currentPage: 1, itemsPerPage: 20, fullNameQuery: '', emailQuery: '', phoneQuery: '', dateBirthFromQuery: '', dateBirthToQuery: ''
  }) {
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('emailQuery', queryParams.emailQuery);
    params = params.append('phoneQuery', queryParams.phoneQuery);
    params = params.append('dateBirthFromQuery', queryParams.dateBirthFromQuery);
    params = params.append('dateBirthToQuery', queryParams.dateBirthToQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'visitor/SearchVisitorsId', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitorsSource.next(res.body);
      }
    })).toPromise();
  }

  getSignature(guid) {

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this.http.get(this.apiUrl + 'visitor/download/' + guid, { headers, responseType: 'blob' });
  }

  exportCSV(queryParams: Partial<VisitorExportQuery> = {}) {
    queryParams = { ...this.defaultVisitorExportQuery, ...queryParams };
    let params = new HttpParams();
    params = params.append('fullNameQuery', queryParams.fullNameQuery);
    params = params.append('emailQuery', queryParams.emailQuery);
    params = params.append('phoneQuery', queryParams.phoneQuery);
    params = params.append('visitorStatusQuery', queryParams.visitorStatusQuery);
    params = params.append('onlyChildren', queryParams.onlyChildren);
    params = params.append('onlyParents', queryParams.onlyParents);
    params = params.append('marketingMessageQuery', queryParams.marketingMessageQuery);
    params = params.append('dateBirthFromQuery', queryParams.dateBirthFromQuery);
    params = params.append('dateBirthToQuery', queryParams.dateBirthToQuery);
    params = params.append('visitorBirthMonthFromQuery', queryParams.visitorBirthMonthFromQuery);
    params = params.append('visitorBirthMonthToQuery', queryParams.visitorBirthMonthToQuery);
    params = params.append('visitorBirthYearFromQuery', queryParams.visitorBirthYearFromQuery);
    params = params.append('visitorBirthYearToQuery', queryParams.visitorBirthYearToQuery);
    params = params.append('roomNameQuery', queryParams.roomNameQuery);

    params = params.append('registrationDateFromQuery', queryParams.registrationDateFromQuery)
    params = params.append('registrationDateToQuery', queryParams.registrationDateToQuery)
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.pageSize);
    return this.http.get(this.apiUrl + 'visitor/exportCSV', { params, responseType: "text" })
  }



  editVisitor(visitor) {
    const formData = new FormData();
    Object.keys(visitor).forEach(key => formData.append(key, visitor[key]));
    // eslint-disable-next-line @typescript-eslint/quotes
    formData.append("children", JSON.stringify(visitor));
    return this.http.put(`${this.apiUrl}Visitor/updateStatusVisitor/${visitor.id}`, visitor);
  }

  getVisitorById(visitorId: number) {
    console.log("visitorIdService",visitorId)
    return this.http.get(`${this.apiUrl}Visitor/${visitorId}`);
  }

// 🔹 nova, tipizovana metoda – samo za precizne slučajeve
getVisitorByIdTyped(visitorId: number) {
  console.log("visitorIdService (typed)", visitorId);
  return this.http.get<Visitor>(`${this.apiUrl}Visitor/${visitorId}`);
}




  getAllBlockedVisitorEdit(queryParams = { currentPage: 1, itemsPerPage: 20, fullNameBlockedVisitorsQuery: '' }) {
    let params = new HttpParams();
    params = params.append('fullNameBlockedVisitorsQuery', queryParams.fullNameBlockedVisitorsQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'Visitor/SearchBlockedVisitors', { params, observe: 'response' }).pipe(map((res: any) => {

      if (res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.visitorsSource.next(res.body);
      }
    })).toPromise();
  }

  addRodjedan(birthdayAdd: BirthDay) {

    return this.http.post(this.apiUrl + 'Rodjendan', { ...birthdayAdd });
  }

   addBirthday(birthdayAdd: BirthdayModelInputDTO) {

    return this.http.post(this.apiUrl + 'Rodjendan', { ...birthdayAdd });
 
 
  }

  getSavedTimeSlots(roomId: number, birthdayZoneId: number, fromInclusive: Date, toExclusive: Date) {
    const params = new HttpParams()
      .set('roomId', roomId.toString())
      .set('birthdayZoneId', birthdayZoneId.toString())
      .set('fromInclusive', fromInclusive.toISOString())
      .set('toExclusive', toExclusive.toISOString());

    return this.http.get<SlotsbyDate[]>(this.apiUrl + 'Rodjendan/SavedTimeSlots', { params });

  }

  getSavedTimeSlotById(savedTimeSlotId: number) {
    return this.http.get(this.apiUrl + 'Rodjendan/by-slot/' + savedTimeSlotId);
  }

getSavedTimeSlotByBirthdayId(savedTimeSlotId: number) {
  return this.http.get<BirthdayModelInputDTO>(
    `${this.apiUrl}Rodjendan/by-birthday-slot/${savedTimeSlotId}`
  );
}


 getSavedTimeSlotByIdStartEnd(savedTimeSlotId: number,savedTimeEndSlotId:number) {
  
  return this.http.get(this.apiUrl + 'Rodjendan/by-slot-range/' + savedTimeSlotId+'/'+savedTimeEndSlotId);
  }  

  saveVisitor(visitor: Visitor1, children: ChildInput[],) {
    const formData = new FormData();
    Object.keys(visitor).forEach(key => formData.append(key, visitor[key]));
    formData.append("children", JSON.stringify(children));
    if (sessionStorage.selectedRoom) {
      formData.append('roomId', sessionStorage.selectedRoom);
    }
    return this.http.post(this.apiUrl + 'visitor/unregistred-visitor', formData);
  }

getParentByPhone(phone: string): Observable<Visitor1 | null> {
  const params = new HttpParams().set('phone', phone);
  return this.http
    .get<Visitor1>(this.apiUrl + 'visitor/lookup/parent-by-phone', { params })
    .pipe(map(v => v ?? null));
}

  getBirthdayBySavedSlot(savedTimeSlotId: number) {
    return this.http.get<BirthdayOutputDTO>(
      `${this.apiUrl}Rodjendan/by-birthday-slot/${savedTimeSlotId}`
    );
  }

  getBirthdayById(birthdayId: number) {
    return this.http.get<BirthdayModelInputDTO>(
      `${this.apiUrl}Rodjendan/${birthdayId}`
    );
  }

updateBirthdayBySlot(dto: BirthdayModelInputDTO ,rodjendanId: number) {
console.log("dto", dto)
console.log("id", rodjendanId)
  return this.http.put<void>(
    `${this.apiUrl}Rodjendan/BirthdayBySlot/${rodjendanId}`,
    dto
  );
}

}



